import { render, staticRenderFns } from "./ShopifyTemplates.vue?vue&type=template&id=abe80c34&"
import script from "./ShopifyTemplates.vue?vue&type=script&lang=js&"
export * from "./ShopifyTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports